import { Platform } from '@enums/Platform';

/**
 * Normalize platform string from backend to frontend Platform enum.
 * Maps various backend platform string formats to the frontend Platform enum.
 * 
 * @param platform - Platform string from backend (e.g., "meta", "google_ads", etc.)
 * @returns Normalized Platform enum value, defaults to Platform.META if not recognized
 */
export const normalizePlatform = (platform?: string): Platform => {
  if (!platform) return Platform.META;
  // Collapse separators and drop an "ads" suffix so display-style strings the
  // agent may emit ("Google Ads", "bing-ads") resolve instead of falling
  // through to the Meta default.
  const normalized = platform.toLowerCase().replace(/[\s-]+/g, '_').replace(/_ads$/, '');
  // Map backend platform values to frontend Platform enum
  switch (normalized) {
    case 'meta':
    case 'facebook':
      return Platform.META;
    case 'google':
      return Platform.GOOGLE;
    case 'tiktok':
      return Platform.TIKTOK;
    case 'amazon':
      return Platform.AMAZON;
    case 'shopify':
      return Platform.SHOPIFY;
    case 'linkedin':
      return Platform.LINKEDIN;
    case 'reddit':
      return Platform.REDDIT;
    case 'bing':
    case 'microsoft':
      return Platform.BING;
    // The agent emits platform="x" on X (Twitter) Ads artifacts; "x_ads" also lands here
    // because the _ads suffix is stripped above. Without this case X chips fell through
    // to the Meta default and rendered the Meta logo.
    case 'x':
    case 'twitter':
      return Platform.X;
    // The agent emits platform="openai" on ChatGPT Ads artifacts (verified on a real
    // campaign→ad group→ad build); "openai_ads"/"chatgpt_ads" land here too because the
    // _ads suffix is stripped above. Without this case the chips fell through to the Meta
    // default and rendered the Meta logo — the same failure the X case above exists for.
    case 'openai':
    case 'chatgpt':
      return Platform.OPENAI;
    default:
      return Platform.META;
  }
};

